import { render, staticRenderFns } from "./tuce.vue?vue&type=template&id=2032c5f1&scoped=true&"
import script from "./tuce.vue?vue&type=script&lang=js&"
export * from "./tuce.vue?vue&type=script&lang=js&"
import style0 from "./tuce.vue?vue&type=style&index=0&id=2032c5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032c5f1",
  null
  
)

export default component.exports